module.exports = __webpack_public_path__ + "img/yalobusha-review-2.abc49aed.png";